import { render } from "./form_management.html?vue&type=template&id=68ed1a33&external"
import script from "./form_management.js?vue&type=script&lang=js&external"
export * from "./form_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__